import { LinkedBottomContent } from './BottomContent/LinkedBottomContent';
import { UnlinkedBottomContent } from './BottomContent/UnlinkedBottomContent';

export const Vigbo = {
    UnlinkedBottomContent,
    LinkedBottomContent,
};
